import useSegmentationStore from '@segmentation/hooks/useSegmentationStore';
import { SegmentationWorkflowOverlay } from '@segmentation/UI/SegmentationWorkflowOverlay';

export function SegmentationProcessingOverlay() {
  const { processingActive, processingPhase, processingJaw } = useSegmentationStore();

  const jawLabel = processingJaw ? `${processingJaw} jaw` : undefined;

  return (
    <SegmentationWorkflowOverlay
      open={processingActive}
      eyebrow={jawLabel ? `Segmenting ${jawLabel}` : 'Segmentation'}
      title="Please hold on while we process the jaw"
      message={processingPhase || 'Starting'}
      variant="loading"
    />
  );
}
